import { render, staticRenderFns } from "./insertCode.vue?vue&type=template&id=4896cbbd&"
import script from "./insertCode.vue?vue&type=script&lang=js&"
export * from "./insertCode.vue?vue&type=script&lang=js&"
import style0 from "./insertCode.vue?vue&type=style&index=0&id=4896cbbd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports